module.exports = __webpack_public_path__ + "img/recurring.4114757d.svg";